export const commentKeys = {
  all: ["comment"] as const,
  best: ["bestComment"] as const,
};
